import { compact, map } from 'lodash';
import ObjectiveApplicant from './ObjectiveApplicant';
import type { IObjectiveCreditHistory } from './ObjectiveCreditHistory.interface';
import { YesNoOption } from '../global/YesNoOption.enum';
import { CreditRecordOption } from '../global/CreditRecordOption.enum';

export default class ObjectiveCreditHistory implements IObjectiveCreditHistory {
  creditRecord: CreditRecordOption;
  creditRecordComments: string;
  applicantHadProblems: YesNoOption;
  applicantHadProblemsComments: string;
  applicantBeenOfficerOrShareholder: YesNoOption;
  applicantBeenOfficerOrShareholderComments: string;
  applicantHaveUnsatisfiedJudgements: YesNoOption;
  applicantHaveUnsatisfiedJudgementsComments: string;
  applicantSubmittedApplicationToOtherCreditProviders: YesNoOption;
  applicantSubmittedApplicationToOtherCreditProvidersComments: string;
  bankruptcy: Array<ObjectiveApplicant>;

  static build = (data: IObjectiveCreditHistory) => new ObjectiveCreditHistory(data);
  static blank = () => new ObjectiveCreditHistory();

  /**
   * Constructor
   * @param {IObjectiveCreditHistory} data
   */
  constructor(data?: IObjectiveCreditHistory) {
    this.creditRecord = CreditRecordOption.of(
      data?.creditRecord?.name || parseInt(data?.creditRecord || 0, 10)
    );
    this.creditRecordComments = data?.creditRecordComments || '';
    this.applicantHadProblems = YesNoOption.of(
      data?.applicantHadProblems?.name || data?.applicantHadProblems?.toString()
    );
    this.applicantHadProblemsComments = data?.applicantHadProblemsComments || '';
    this.applicantBeenOfficerOrShareholder = YesNoOption.of(
      data?.applicantBeenOfficerOrShareholder?.name ||
        data?.applicantBeenOfficerOrShareholder?.toString()
    );
    this.applicantBeenOfficerOrShareholderComments =
      data?.applicantBeenOfficerOrShareholderComments || '';
    this.applicantHaveUnsatisfiedJudgements = YesNoOption.of(
      data?.applicantHaveUnsatisfiedJudgements?.name ||
        data?.applicantHaveUnsatisfiedJudgements?.toString()
    );
    this.applicantHaveUnsatisfiedJudgementsComments =
      data?.applicantHaveUnsatisfiedJudgementsComments || '';
    this.applicantSubmittedApplicationToOtherCreditProviders = YesNoOption.of(
      data?.applicantSubmittedApplicationToOtherCreditProviders?.name ||
        data?.applicantSubmittedApplicationToOtherCreditProviders?.toString()
    );
    this.applicantSubmittedApplicationToOtherCreditProvidersComments =
      data?.applicantSubmittedApplicationToOtherCreditProvidersComments || '';
    this.bankruptcy = map(
      compact(data?.bankruptcy),
      (obj) => new ObjectiveApplicant(obj, 'bankruptcy')
    );
  }
}
